var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFotoflowProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199.74,
    height: 195.831,
    viewBox: "0 0 199.74 195.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.491,
    y1: 0.997,
    x2: 0.53,
    y2: 0.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d932f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274a18",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_32",
    x: 0,
    y: 28.768,
    width: 133.156,
    height: 134.942,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d932f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#4b902e",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#448229",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274a18",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_47",
    x: 21.801,
    y: 45.102,
    width: 76.964,
    height: 79.429,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.718
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9dd63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#75af34",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#4d922f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#4b902e",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#448229",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2f591c",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172e0d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_33",
    x: 27.862,
    y: 70.11,
    width: 99.188,
    height: 97.804,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_45",
    x: 34.102,
    y: 92.325,
    width: 68.53,
    height: 66.638,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.467
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.482,
    y1: 0.992,
    x2: 0.433,
    y2: 0.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47882b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#2d6117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#264e15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#315d1d",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274a18",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_34",
    x: 37.681,
    y: 33.772,
    width: 162.059,
    height: 162.059,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.569
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_49",
    x: 70.262,
    y: 65.772,
    width: 79.46,
    height: 79.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.718
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88b53f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#549a31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4c902e",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#488b2c",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#376922",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2d561c",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f4011",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_29",
    x: 66.089,
    y: 45.061,
    width: 86.632,
    height: 86.632,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.616
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_46",
    x: 69.508,
    y: 61.215,
    width: 63.95,
    height: 63.95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.718
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.473,
    y1: 0.986,
    x2: 0.549,
    y2: -0.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47882b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#47872a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#4b902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#47882b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#34621f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#284b18",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274a18",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_40",
    x: 39.343,
    y: 0,
    width: 125.451,
    height: 126.111,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: -13,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_48",
    x: 55.205,
    y: 44.69,
    width: 43.958,
    height: 45.251,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.718
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "matrix(1, -0.017, 0.017, 1, -597.484, -36.885)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, 596.75, 47.31)",
    filter: "url(#Rectangle_32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_32-2",
    "data-name": "Rectangle 32",
    transform: "translate(41.74 139.71) rotate(-136)",
    stroke: "rgba(202,255,131,0.07)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.662,
    height: 97.048,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23.662,
    height: 96.048,
    rx: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, 596.75, 47.31)",
    filter: "url(#Rectangle_47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_47-2",
    "data-name": "Rectangle 47",
    transform: "translate(94.97 49.1) rotate(44)",
    stroke: "#caff83",
    strokeWidth: 2,
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 1.111,
    height: 101.005,
    rx: 0.556,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1.1114623546600342M1,0v101.00546264648438M1.1114623546600342,100.00546264648438h-1.1114623546600342M0.11146235466003418,101.00546264648438v-101.00546264648438",
    fill: "none",
    clipPath: "url(#clip)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, 596.75, 47.31)",
    filter: "url(#Rectangle_33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_33-2",
    "data-name": "Rectangle 33",
    transform: "translate(39.86 103.85) rotate(-46)",
    stroke: "rgba(202,255,131,0.07)",
    strokeWidth: 1,
    fill: "url(#linear-gradient-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0H23.662a1,1,0,0,1,1,1V80.707a0,0,0,0,1,0,0H2a2,2,0,0,1-2-2V3A3,3,0,0,1,3,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,.5H23.662a.5.5,0,0,1,.5.5V80.207a0,0,0,0,1,0,0H2a1.5,1.5,0,0,1-1.5-1.5V3A2.5,2.5,0,0,1,3,.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, 596.75, 47.31)",
    filter: "url(#Rectangle_45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    transform: "translate(40.1 104.04) rotate(-46)",
    stroke: "#caff83",
    strokeWidth: 2,
    opacity: 0.4,
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 0.995,
    height: 77.624,
    rx: 0.498,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h0.9953114986419678M1,0v77.62416076660156M0.9953114986419678,76.62416076660156h-0.9953114986419678M-0.0046885013580322266,77.62416076660156v-77.62416076660156",
    fill: "none",
    clipPath: "url(#clip-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "matrix(1, 0.017, -0.017, 1, 3.278, -11.181)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 594.4, 48.12)",
    filter: "url(#Rectangle_34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34-2",
    "data-name": "Rectangle 34",
    transform: "translate(146.3 69.77) rotate(45)",
    stroke: "rgba(202,255,131,0.07)",
    strokeWidth: 1,
    fill: "url(#linear-gradient-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H23.662a1,1,0,0,1,1,1v99.7a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,.5H23.662a.5.5,0,0,1,.5.5v99.7a1.5,1.5,0,0,1-1.5,1.5H2a1.5,1.5,0,0,1-1.5-1.5V2A1.5,1.5,0,0,1,2,.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 594.4, 48.12)",
    filter: "url(#Rectangle_49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_49-2",
    "data-name": "Rectangle 49",
    transform: "translate(145.94 69.77) rotate(45)",
    stroke: "#caff83",
    strokeWidth: 2,
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-3",
    width: 1.111,
    height: 102.777,
    rx: 0.556,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1.1114623546600342M1,0v102.77710723876953M1.1114623546600342,101.77710723876953h-1.1114623546600342M0.11146235466003418,102.77710723876953v-102.77710723876953",
    fill: "none",
    clipPath: "url(#clip-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 594.4, 48.12)",
    filter: "url(#Rectangle_29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_29-2",
    "data-name": "Rectangle 29",
    transform: "translate(146.72 105.25) rotate(135)",
    stroke: "rgba(202,255,131,0.07)",
    strokeWidth: 1,
    fill: "url(#linear-gradient-7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0H20.662a4,4,0,0,1,4,4V79.884a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H20.662a3.5,3.5,0,0,1,3.5,3.5V79.884a.5.5,0,0,1-.5.5H1a.5.5,0,0,1-.5-.5V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 594.4, 48.12)",
    filter: "url(#Rectangle_46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_46-2",
    "data-name": "Rectangle 46",
    transform: "translate(72.51 66) rotate(-45)",
    stroke: "#caff83",
    strokeWidth: 2,
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-4",
    width: 1.111,
    height: 80.843,
    rx: 0.556,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1.1114623546600342M1,0v80.84286499023438M1.1114623546600342,79.84286499023438h-1.1114623546600342M0.11146235466003418,80.84286499023438v-80.84286499023438",
    fill: "none",
    clipPath: "url(#clip-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, 596.75, 47.31)",
    filter: "url(#Rectangle_40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40-2",
    "data-name": "Rectangle 40",
    d: "M2,0H22.662a2,2,0,0,1,2,2V45.407a6,6,0,0,1-6,6H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(77.08 103.11) rotate(-136)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, 596.75, 47.31)",
    filter: "url(#Rectangle_48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_48-2",
    "data-name": "Rectangle 48",
    transform: "translate(95.36 48.69) rotate(44)",
    stroke: "#caff83",
    strokeWidth: 2,
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-5",
    width: 1.111,
    height: 53.491,
    rx: 0.556,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1.1114623546600342M1,0v53.49134826660156M1.1114623546600342,52.49134826660156h-1.1114623546600342M0.11146235466003418,53.49134826660156v-53.49134826660156",
    fill: "none",
    clipPath: "url(#clip-5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFotoflowProLogo);
export default __webpack_public_path__ + "static/media/fotoflow-pro-logo.8e2bd4a82da33c098337a3a6731a25fa.svg";
export { ForwardRef as ReactComponent };